/**
 * MagicPosterPanel 类型定义
 */
import { TReportStepType, IReportFileItem, IReportUpdateParams } from '../../../components/ReportViewer/types';

/** 海报步骤类型 */
export type TPosterStepType = TReportStepType; // 复用 'framework' | 'report'

/** 海报风格模板（最小化数据结构：只存储必要的标识信息） */
export interface IPosterStyleTemplate {
  /** 模板 ID（预设模板：templateId；自定义：'custom'） */
  id: string;
  /** 是否为自定义选项 */
  isCustom?: boolean;
}

/** 选中的风格信息 */
export interface ISelectedStyle {
  /** 选中的模板 */
  template: IPosterStyleTemplate | null;
  /** 自定义输入内容（仅当 template.isCustom 时有效） */
  customInput: string;
}

/** 海报数据 */
export interface IPosterData {
  /** 海报图片 URL */
  imageUrl?: string;
  /** 海报生成状态 */
  status?: 'idle' | 'generating' | 'success' | 'error';
  /** 错误信息 */
  errorMessage?: string;
}

/** 海报操作枚举 */
export enum EPosterActions {
  /** Step1: 重置内容规划 */
  FrameworkReset = 'poster_framework_reset',
  /** Step1: 生成魔法海报 */
  GeneratePoster = 'poster_generate',
  /** Step2: 重新生成 */
  Regenerate = 'poster_regenerate',
  /** Step2: 导出 */
  Export = 'poster_export',
  /** Step2: 分享 */
  Share = 'poster_share',
}

/** 海报导出类型 */
export enum EPosterExportType {
  PNG = 'png',
  JPG = 'jpg',
}

/** MagicPosterPanel Props */
export interface IMagicPosterPanelProps {
  /** 会话 ID */
  sessionId: string;
  /** 会话列表 */
  conversations: unknown[];
  /** 报告数据（复用 dsReport 结构） */
  dsReport: any;
  /** 流式状态 */
  streamingState: string;
  /** 报告更新回调 */
  handleUpdateDsReport: (update: IReportUpdateParams) => void;
  /** 开始新对话回调 */
  startNewConversation: (...args: unknown[]) => void;
  /** 是否为只读模式（分享场景下为 true，禁用重置/生成/重新生成/分享按钮） */
  readonly?: boolean;
  /** 是否显示关闭按钮 */
  showCloseButton?: boolean;
  /** 自定义类名 */
  className?: string;
  /** 头部鼠标按下事件 - 用于支持拖拽 */
  onHeaderMouseDown?: (e: React.MouseEvent) => void;
  /** 窗口聚焦回调 */
  onFocus?: () => void;
}

/** PosterStyleSelector Props */
export interface IPosterStyleSelectorProps {
  /** 当前选中的风格 */
  selectedStyle: ISelectedStyle;
  /** 风格变更回调 */
  onStyleChange: (style: ISelectedStyle) => void;
  /** 是否禁用 */
  disabled?: boolean;
  /** 自定义类名 */
  className?: string;
}

/** PosterPreviewPanel Props */
export interface IPosterPreviewPanelProps {
  /** 海报图片 URL */
  imageUrl?: string;
  /** 是否加载中（无图片时默认 loading） */
  isLoading: boolean;
  /** 图片加载失败时的重试回调 */
  onRetry?: () => void | Promise<void>;
  /** 自定义类名 */
  className?: string;
}

export { IReportFileItem };
